<template>
    <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/>
</template>

<script>
    export default {
        name: 'arrow-left',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/ArrowLeft.vue